import React from 'react';
import { ColorPickerProps } from './types';
import { hslToHex, hexToHsl } from './colorVariables';

/**
 * Color picker component for editing individual color variables
 */
export const ColorPicker: React.FC<ColorPickerProps> = ({
  variable,
  lightValue,
  darkValue,
  onLightChange,
  onDarkChange,
  compact = false
}) => {
  const handleLightColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const hex = e.target.value;
    const hsl = hexToHsl(hex);
    onLightChange(hsl);
  };

  const handleDarkColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const hex = e.target.value;
    const hsl = hexToHsl(hex);
    onDarkChange(hsl);
  };

  const handleLightTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onLightChange(e.target.value);
  };

  const handleDarkTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onDarkChange(e.target.value);
  };

  return (
    <div className="form-group">
      <div className="flex items-center justify-between mb-2">
        <label className="form-label">
          {variable.displayName}
          <span className="text-xs text-foreground-muted ml-1">({variable.name})</span>
        </label>
        {variable.description && (
          <span className="text-xs text-foreground-muted max-w-xs text-right">
            {variable.description}
          </span>
        )}
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        {/* Light Mode */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground-muted">Light Mode</label>
          <div className="flex space-x-2">
            <input
              type="color"
              value={hslToHex(lightValue)}
              onChange={handleLightColorChange}
              className="w-12 h-10 rounded border border-border cursor-pointer"
              title={`Pick color for ${variable.displayName} (Light)`}
            />
            <input
              type="text"
              value={lightValue}
              onChange={handleLightTextChange}
              placeholder="H S% L%"
              className="form-input flex-1 text-sm"
            />
          </div>
        </div>
        
        {/* Dark Mode */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground-muted">Dark Mode</label>
          <div className="flex space-x-2">
            <input
              type="color"
              value={hslToHex(darkValue)}
              onChange={handleDarkColorChange}
              className="w-12 h-10 rounded border border-border cursor-pointer"
              title={`Pick color for ${variable.displayName} (Dark)`}
            />
            <input
              type="text"
              value={darkValue}
              onChange={handleDarkTextChange}
              placeholder="H S% L%"
              className="form-input flex-1 text-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
